import type { ShopperAgentOutreachCondition } from "@redotech/redo-flows-common/rules-v3/schemas";
import {
  SHOPPER_AGENT_OUTREACH_CONDITION_VALUES,
  type ShopperAgentOutreachConditionValue,
} from "@redotech/redo-flows-common/rules-v3/types";
import {
  QueryOperator,
  RuleConditionType,
} from "@redotech/redo-flows-common/rules/types";

const OUTREACH_TOPIC_VALUES = SHOPPER_AGENT_OUTREACH_CONDITION_VALUES.filter(
  (value): value is Exclude<ShopperAgentOutreachConditionValue, "none"> =>
    value !== "none",
);

/** Every outreach kind but `none`: IS means the thread has an outreach topic. */
export function shopperAgentOutreachLaneCondition(
  queryOperator: QueryOperator.IS | QueryOperator.IS_NOT,
): ShopperAgentOutreachCondition {
  return {
    conditionType: RuleConditionType.SHOPPER_AGENT_OUTREACH,
    outreachTypes: [...OUTREACH_TOPIC_VALUES],
    queryOperator,
  };
}
